(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["es-ornament-lead"] && !Shopify.designMode) return;
  try {
    
  (function (global) {
    'use strict';

    var DAY_MS = 86400000;
    var STATE_KEY = 'es_acq_gate_v2';
    var SESSION_KEY = 'es_acq_seen_v2';
    var SESSION_COOKIE = 'es_acq_seen';
    var COOLDOWN_COOKIE = 'es_acq_next';
    var COMPETING_FORM_SELECTOR = [
      '[data-testid="klaviyo-form-XnUsp4"]',
      '[data-testid="klaviyo-form-XYJYUX"]',
      '.klaviyo-form-XnUsp4',
      '.klaviyo-form-XYJYUX'
    ].join(',');

    function suppressCompetingPopups(scope) {
      var forms = [];
      if (scope.nodeType === 1 && scope.matches(COMPETING_FORM_SELECTOR)) forms.push(scope);
      if (scope.querySelectorAll) forms = forms.concat(Array.from(scope.querySelectorAll(COMPETING_FORM_SELECTOR)));
      forms.forEach(function (form) {
        var target = form.closest('[data-testid="POPUP"], [data-testid="FLYOUT"], [role="dialog"]') || form;
        var parent = target.parentElement;
        while (parent && parent !== global.document.body) {
          if (global.getComputedStyle(parent).position === 'fixed') target = parent;
          parent = parent.parentElement;
        }
        target.setAttribute('data-es-ornament-suppressed', 'true');
        target.setAttribute('aria-hidden', 'true');
        target.style.setProperty('display', 'none', 'important');
      });
    }

    function preventCompetingPopups() {
      suppressCompetingPopups(global.document);
      if (global.__ES_ORNAMENT_POPUP_GUARD__) return;
      global.__ES_ORNAMENT_POPUP_GUARD__ = true;
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) suppressCompetingPopups(node);
          });
        });
      }).observe(global.document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    function suppressConflictingReferralBanner() {
      var banner = global.document.querySelector('[data-section-type="announcement-bar"]');
      if (!banner || !/REFERRAL10/i.test(banner.textContent || '')) return;
      var wrapper = banner.closest('.shopify-section') || banner;
      wrapper.hidden = true;
      wrapper.setAttribute('aria-hidden', 'true');
    }

    function safeJson(value, fallback) {
      try { return JSON.parse(value || '') || fallback; } catch (error) { return fallback; }
    }

    function markSession() {
      try { global.sessionStorage.setItem(SESSION_KEY, '1'); } catch (error) {}
      global.__ES_ACQUISITION_SEEN__ = true;
      global.document.cookie = SESSION_COOKIE + '=1; Path=/; SameSite=Lax' + (global.location.protocol === 'https:' ? '; Secure' : '');
    }

    function markClaimed() {
      var now = Date.now();
      var next = now + 30 * DAY_MS;
      var state = {};
      try { state = safeJson(global.localStorage.getItem(STATE_KEY), {}); } catch (error) {}
      state.nextEligibleAt = next;
      state.claimed = state.claimed || {};
      state.claimed.christmas_sewing_pattern = now;
      state.lastOffer = 'christmas_sewing_pattern';
      try { global.localStorage.setItem(STATE_KEY, JSON.stringify(state)); } catch (error) {}
      global.document.cookie = COOLDOWN_COOKIE + '=' + next + '; Path=/; Max-Age=' + (30 * 86400) + '; SameSite=Lax' + (global.location.protocol === 'https:' ? '; Secure' : '');
      markSession();
    }

    function emit(name, detail) {
      var eventName = 'es_ornament_' + name;
      var eventData = detail || {};
      if (Array.isArray(global.dataLayer)) global.dataLayer.push(Object.assign({ event: eventName }, eventData));
      if (global.Shopify && global.Shopify.analytics && typeof global.Shopify.analytics.publish === 'function') {
        var published = global.Shopify.analytics.publish('es_ornament:' + name, eventData);
        if (published && typeof published.catch === 'function') published.catch(function () {});
      }
    }

    // The only Meta Lead for this form. Pixel 171335343667577 otherwise runs inside the sandboxed custom
    // pixel, which never sees this event. Do not also map es_ornament:signup_success to Lead there.
    var META_PIXEL_ID = '171335343667577';
    var leadTracked = false;

    function adTrackingAllowed() {
      var privacy = global.Shopify && global.Shopify.customerPrivacy;
      if (!privacy) return false;
      try {
        return privacy.marketingAllowed() === true &&
          privacy.analyticsProcessingAllowed() === true &&
          privacy.saleOfDataAllowed() === true;
      } catch (error) {
        return false;
      }
    }

    function whenAdTrackingAllowed(callback) {
      if (global.Shopify && global.Shopify.customerPrivacy) {
        if (adTrackingAllowed()) callback();
        return;
      }
      if (!global.Shopify || typeof global.Shopify.loadFeatures !== 'function') return;
      global.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error && adTrackingAllowed()) callback();
      });
    }

    function ensureMetaPixel() {
      if (typeof global.fbq === 'function') return;
      var fbq = global.fbq = function () {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      if (!global._fbq) global._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      var script = global.document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      global.document.head.appendChild(script);
      fbq('set', 'autoConfig', false, META_PIXEL_ID);
      fbq('init', META_PIXEL_ID);
    }

    function trackLead() {
      if (leadTracked) return;
      leadTracked = true;
      try {
        var eventId = 'es_orn_lead_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
        whenAdTrackingAllowed(function () {
          try {
            ensureMetaPixel();
            global.fbq('trackSingle', META_PIXEL_ID, 'Lead', {
              content_name: 'Free Christmas Sewing Pattern',
              content_category: 'lead_magnet',
              currency: 'USD',
              value: 0
            }, { eventID: eventId });
          } catch (error) {}
        });
      } catch (error) {}
    }

    function initialize(root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      preventCompetingPopups();
      suppressConflictingReferralBanner();
      markSession();
      emit('landing_view', { offer: 'christmas_sewing_pattern' });

      var form = root.querySelector('[data-es-ornament-form]');
      var status = root.querySelector('[data-es-ornament-status]');
      var emailStep = form.querySelector('[data-es-ornament-email-step]');
      var smsStep = form.querySelector('[data-es-ornament-sms-step]');
      var successPanel = form.querySelector('[data-es-ornament-success]');
      var nextButton = form.querySelector('[data-es-ornament-next]');
      var submitButton = form.querySelector('[data-es-ornament-submit]');
      var skipButton = form.querySelector('[data-es-ornament-skip]');
      var emailInput = form.elements.email;
      var emailConsent = form.elements.marketing_consent;
      var phoneInput = form.elements.phone;
      var smsConsent = form.elements.sms_consent;
      var preview = root.dataset.previewMode === 'true' || Boolean(global.Shopify && global.Shopify.designMode);

      function normalizePhone(value) {
        var raw = String(value || '').trim();
        if (!raw) return '';
        if (raw.charAt(0) === '+') {
          var internationalDigits = raw.slice(1).replace(/\D/g, '');
          return internationalDigits.length >= 8 && internationalDigits.length <= 15 ? '+' + internationalDigits : '';
        }
        var digits = raw.replace(/\D/g, '');
        if (digits.length === 10) return '+1' + digits;
        if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
        return '';
      }

      function setBusy(isBusy) {
        [nextButton, submitButton, skipButton].forEach(function (control) {
          if (control) control.disabled = isBusy;
        });
      }

      function showSuccess(isSmsSubscriber) {
        emailStep.hidden = true;
        smsStep.hidden = true;
        successPanel.hidden = false;
        successPanel.dataset.smsSubscribed = isSmsSubscriber ? 'true' : 'false';
        successPanel.focus();
      }

      function showSmsStep(message) {
        status.textContent = '';
        emailStep.hidden = true;
        smsStep.hidden = false;
        status.textContent = message || root.dataset.emailSavedMessage;
        phoneInput.focus();
        emit('email_step_completed', { offer: 'christmas_sewing_pattern' });
      }

      function subscriptionPayload(includeSms) {
        var formData = new FormData(form);
        var email = String(formData.get('email') || '').trim();
        var resourceUrl = root.dataset.resourceUrl;
        var params = new URLSearchParams(global.location.search);
        var properties = {
          es_offer: 'christmas_sewing_pattern',
          es_interest: 'ornament_sewing',
          es_signup_source: 'website',
          es_signup_page: global.location.pathname,
          es_offer_version: root.dataset.offerVersion || 'evergreen_v2',
          es_resource_url: resourceUrl,
          es_sms_opt_in: includeSms
        };
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
          var value = params.get(key);
          if (value) properties['es_' + key] = value.slice(0, 160);
        });

        var profileAttributes = {
          email: email,
          subscriptions: {},
          properties: properties
        };
        if (includeSms) {
          profileAttributes.phone_number = normalizePhone(formData.get('phone'));
          profileAttributes.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
        } else {
          profileAttributes.subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } };
        }

        return {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: profileAttributes
                }
              },
              custom_source: 'ES Free Christmas Sewing Pattern'
            },
            relationships: { list: { data: { type: 'list', id: root.dataset.listId } } }
          }
        };
      }

      async function postSubscription(includeSms) {
        var controller = new AbortController();
        var timer = global.setTimeout(function () { controller.abort(); }, 20000);
        try {
          var response = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.companyId), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
            body: JSON.stringify(subscriptionPayload(includeSms)),
            signal: controller.signal
          });
          if (!response.ok) throw new Error('subscription_failed');
        } finally {
          global.clearTimeout(timer);
        }
      }

      var emailCaptured = false;

      async function captureEmail() {
        if (nextButton.disabled || !emailInput.reportValidity() || !emailConsent.reportValidity()) return;
        if (form.elements.company.value) return;
        if (!root.dataset.resourceUrl) {
          status.textContent = root.dataset.missingUrl;
          return;
        }
        if (preview) {
          emailCaptured = true;
          showSmsStep(root.dataset.previewMessage);
          return;
        }

        setBusy(true);
        status.textContent = root.dataset.sendingMessage;
        try {
          await postSubscription(false);
          emailCaptured = true;
          markClaimed();
          emit('signup_success', { offer: 'christmas_sewing_pattern', sms_opt_in: false, destination: 'email' });
          trackLead();
          showSmsStep();
        } catch (error) {
          status.textContent = root.dataset.errorMessage;
          emit('signup_failed', { offer: 'christmas_sewing_pattern' });
        } finally {
          setBusy(false);
        }
      }

      async function captureSms() {
        if (submitButton.disabled || !emailCaptured) return;
        var phone = normalizePhone(phoneInput.value);
        if (!phone) {
          status.textContent = root.dataset.phoneError;
          phoneInput.focus();
          return;
        }
        if (!smsConsent.checked) {
          status.textContent = root.dataset.smsConsentError;
          smsConsent.focus();
          return;
        }
        if (preview) {
          status.textContent = root.dataset.previewMessage;
          showSuccess(true);
          return;
        }

        setBusy(true);
        status.textContent = root.dataset.smsSendingMessage;
        try {
          await postSubscription(true);
          status.textContent = root.dataset.smsSuccessMessage;
          emit('sms_signup_success', { offer: 'christmas_sewing_pattern' });
          showSuccess(true);
        } catch (error) {
          status.textContent = root.dataset.smsErrorMessage;
          emit('sms_signup_failed', { offer: 'christmas_sewing_pattern' });
        } finally {
          setBusy(false);
        }
      }

      nextButton.addEventListener('click', captureEmail);
      skipButton.addEventListener('click', function () {
        phoneInput.value = '';
        smsConsent.checked = false;
        showSuccess(false);
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (smsStep.hidden) captureEmail();
        else captureSms();
      });
    }

    function scan(scope) {
      (scope || global.document).querySelectorAll('[data-es-ornament-lead]').forEach(initialize);
    }

    if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', function () { scan(); }, { once: true });
    else scan();
    global.document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  })(window);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-ornament-resource"] && !Shopify.designMode) return;
  try {
    
  (function (global) {
    'use strict';

    var COMPETING_FORM_SELECTOR = [
      '[data-testid="klaviyo-form-XnUsp4"]',
      '[data-testid="klaviyo-form-XYJYUX"]',
      '.klaviyo-form-XnUsp4',
      '.klaviyo-form-XYJYUX'
    ].join(',');

    function suppressCompetingPopups(scope) {
      var forms = [];
      if (scope.nodeType === 1 && scope.matches(COMPETING_FORM_SELECTOR)) forms.push(scope);
      if (scope.querySelectorAll) forms = forms.concat(Array.from(scope.querySelectorAll(COMPETING_FORM_SELECTOR)));
      forms.forEach(function (form) {
        var target = form.closest('[data-testid="POPUP"], [data-testid="FLYOUT"], [role="dialog"]') || form;
        var parent = target.parentElement;
        while (parent && parent !== global.document.body) {
          if (global.getComputedStyle(parent).position === 'fixed') target = parent;
          parent = parent.parentElement;
        }
        target.setAttribute('data-es-ornament-suppressed', 'true');
        target.setAttribute('aria-hidden', 'true');
        target.style.setProperty('display', 'none', 'important');
      });
    }

    function preventCompetingPopups() {
      suppressCompetingPopups(global.document);
      if (global.__ES_ORNAMENT_POPUP_GUARD__) return;
      global.__ES_ORNAMENT_POPUP_GUARD__ = true;
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) suppressCompetingPopups(node);
          });
        });
      }).observe(global.document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    function suppressConflictingReferralBanner() {
      var banner = global.document.querySelector('[data-section-type="announcement-bar"]');
      if (!banner || !/REFERRAL10/i.test(banner.textContent || '')) return;
      var wrapper = banner.closest('.shopify-section') || banner;
      wrapper.hidden = true;
      wrapper.setAttribute('aria-hidden', 'true');
    }

    function markSession() {
      try { global.sessionStorage.setItem('es_acq_seen_v2', '1'); } catch (error) {}
      global.__ES_ACQUISITION_SEEN__ = true;
      global.document.cookie = 'es_acq_seen=1; Path=/; SameSite=Lax' + (global.location.protocol === 'https:' ? '; Secure' : '');
    }

    function emit(name, detail) {
      var eventName = 'es_ornament_' + name;
      var eventData = detail || {};
      if (Array.isArray(global.dataLayer)) global.dataLayer.push(Object.assign({ event: eventName }, eventData));
      if (global.Shopify && global.Shopify.analytics && typeof global.Shopify.analytics.publish === 'function') {
        var published = global.Shopify.analytics.publish('es_ornament:' + name, eventData);
        if (published && typeof published.catch === 'function') published.catch(function () {});
      }
    }

    function initialize(root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';
      preventCompetingPopups();
      suppressConflictingReferralBanner();
      markSession();
      emit('resource_view', { offer: 'christmas_sewing_pattern' });

      var video = root.querySelector('[data-es-tutorial-video]');
      var videoSource = root.querySelector('[data-es-video-source]');
      var captionTrack = root.querySelector('[data-es-caption-track]');
      var videoPartButtons = Array.from(root.querySelectorAll('[data-es-video-part]'));

      function selectVideoPart(part, shouldPlay) {
        if (!video || !videoSource) return;
        var url = part === '2' ? root.dataset.videoPartTwo : root.dataset.videoPartOne;
        var captionUrl = part === '2' ? root.dataset.captionPartTwo : root.dataset.captionPartOne;
        if (!url) return;
        if (videoSource.getAttribute('src') !== url) {
          video.pause();
          videoSource.setAttribute('src', url);
          if (captionTrack && captionUrl) captionTrack.setAttribute('src', captionUrl);
          video.load();
        }
        videoPartButtons.forEach(function (button) {
          button.setAttribute('aria-current', button.dataset.esVideoPart === part ? 'true' : 'false');
        });
        emit('video_part_selected', { offer: 'christmas_sewing_pattern', part: part });
        if (shouldPlay) {
          var playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(function () {});
        }
      }

      videoPartButtons.forEach(function (button) {
        button.addEventListener('click', function () { selectVideoPart(button.dataset.esVideoPart, true); });
      });
      if (video) {
        video.addEventListener('ended', function () {
          var current = root.querySelector('[data-es-video-part][aria-current=true]');
          if (current && current.dataset.esVideoPart === '1') selectVideoPart('2', true);
        });
      }

      var copyButton = root.querySelector('[data-es-copy-code]');
      if (copyButton) {
        copyButton.addEventListener('click', function () {
          var code = root.dataset.discountCode;
          if (!code) return;

          function legacyCopy() {
            var field = global.document.createElement('textarea');
            field.value = code;
            field.setAttribute('readonly', '');
            field.style.position = 'fixed';
            field.style.left = '-9999px';
            global.document.body.appendChild(field);
            field.select();
            var copied = false;
            try { copied = global.document.execCommand('copy'); } catch (error) {}
            field.remove();
            return copied;
          }

          function showCopied() {
            copyButton.textContent = root.dataset.copySuccess;
            emit('discount_copy', { offer: 'christmas_sewing_pattern', product: 'fleury_brocade' });
          }

          function showManualCopy() {
            var codeDisplay = root.querySelector('[data-es-discount-code]');
            if (codeDisplay && global.getSelection) {
              var selection = global.getSelection();
              var range = global.document.createRange();
              range.selectNodeContents(codeDisplay);
              selection.removeAllRanges();
              selection.addRange(range);
              codeDisplay.focus();
            }
            copyButton.textContent = root.dataset.copyFallback;
          }

          if (global.navigator.clipboard && global.isSecureContext) {
            global.navigator.clipboard.writeText(code).then(showCopied).catch(function () {
              if (legacyCopy()) showCopied();
              else showManualCopy();
            });
          } else if (legacyCopy()) showCopied();
          else showManualCopy();
        });
      }

      var download = root.querySelector('[data-es-pattern-download]');
      if (download) download.addEventListener('click', function () { emit('pattern_download', { offer: 'christmas_sewing_pattern' }); });
      var product = root.querySelector('[data-es-fleury-link]');
      if (product) product.addEventListener('click', function () { emit('product_click', { offer: 'christmas_sewing_pattern', product: 'fleury_brocade' }); });
      var transcript = root.querySelector('[data-es-transcript-link]');
      if (transcript) transcript.addEventListener('click', function () { emit('transcript_open', { offer: 'christmas_sewing_pattern' }); });
    }

    function scan(scope) {
      (scope || global.document).querySelectorAll('[data-es-ornament-resource]').forEach(initialize);
    }

    if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', function () { scan(); }, { once: true });
    else scan();
    global.document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  })(window);

  } catch(e) { console.error(e); }
})();
})();
